var map = {
	"./additionalInfoIcon.svg": 547,
	"./arrowLeftIcon.svg": 548,
	"./arrowMediumTop.svg": 549,
	"./arrowRightIcon.svg": 550,
	"./arrowRightIconSharp.svg": 551,
	"./arrowRightSmallIcon.svg": 552,
	"./arrowScalableIcon.svg": 553,
	"./arrowSelect2.svg": 554,
	"./arrowSelectIcon.svg": 555,
	"./benefit1.svg": 556,
	"./benefit2.svg": 557,
	"./benefit3.svg": 558,
	"./cardsIcon.svg": 559,
	"./checkCirсleIcon.svg": 560,
	"./circleInfoIcon.svg": 561,
	"./copyIcon copy.svg": 562,
	"./copyIcon.svg": 563,
	"./crossIcon.svg": 564,
	"./crossIcon2.svg": 565,
	"./crossIcon3.svg": 566,
	"./crossIconSmall.svg": 567,
	"./crossSmallIcon.svg": 568,
	"./defaultCategoryIcon.svg": 569,
	"./depNumberIcon.svg": 570,
	"./elfCentralIcon.svg": 571,
	"./equalitySign.svg": 572,
	"./errorIcon.svg": 458,
	"./eyeClosedIcon.svg": 573,
	"./eyeOpenIcon.svg": 574,
	"./favoritesIcon.svg": 575,
	"./favoritesLabelIcon.svg": 576,
	"./filterDivider.svg": 577,
	"./filterIcon.svg": 578,
	"./frequencyIcon.svg": 579,
	"./fsAmountIcon.svg": 580,
	"./fullScreenIcon.svg": 581,
	"./gameIcon.svg": 582,
	"./goldGiftIcon.svg": 583,
	"./hamburgerIcon.svg": 584,
	"./infoIcon.svg": 585,
	"./infoSymbol.svg": 586,
	"./levelBackground.svg": 587,
	"./levelBackgroundNew.svg": 588,
	"./linkIcon.svg": 589,
	"./lockIcon.svg": 590,
	"./lockSharpIcon.svg": 591,
	"./maxBonusAmountIcon.svg": 592,
	"./maxWinFsIcon.svg": 593,
	"./menuIcon.svg": 594,
	"./minDepIcon.svg": 595,
	"./noTournamentIcon.svg": 596,
	"./playIcon.svg": 597,
	"./polygon.svg": 598,
	"./preloaderDotsAnimation.svg": 599,
	"./preloaderSpinnerAnimation.svg": 600,
	"./present2Icon.svg": 601,
	"./presentIcon.svg": 602,
	"./promoIcon.svg": 603,
	"./recentIcon.svg": 604,
	"./search2Icon.svg": 605,
	"./search3Icon.svg": 606,
	"./sharpTickIcon copy.svg": 607,
	"./sharpTickIcon.svg": 608,
	"./smallInfoSymbol.svg": 609,
	"./smoothArrowIcon.svg": 610,
	"./successIcon.svg": 611,
	"./supportIcon.svg": 612,
	"./tag1Icon.svg": 613,
	"./tag2Icon.svg": 614,
	"./tag3Icon.svg": 615,
	"./tag4Icon.svg": 616,
	"./tickIcon.svg": 617,
	"./unverified.svg": 618,
	"./verified.svg": 619,
	"./wagerIcon.svg": 620,
	"./wagerTimeIcon.svg": 621,
	"./warningIcon.svg": 622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 546;